// IngredientGroupList.jsx
import ItemBlock from "../components/ItemBlock";
import RadioBlock from "../components/RadioBlock";

export function mapIngredientsBySettings(ingredients, settings) {
    const result = {
        addOns: [],
        extras: [],
        removables: [],
        steps: {},
        infoOnly: [],
    };

    for (const ing of ingredients) {
        if (!ing?.p0text?.trim()) continue;

        const sort = parseInt(ing.p0sort, 10);
        const isHidden = sort >= settings.hidden.min;
        if(isHidden)continue;
        const realSort = isHidden ? sort - settings.hidden.offset : sort;
        const [type, cat, idx] = realSort.toString().padStart(3, "0").split("");
        const typeDef = settings?.[type];

        const ingredient = {
            ...ing,
            _meta: { type, cat, idx, isHidden, typeDef }
        };

        if (typeDef.infoOnly) {
            result.infoOnly.push(ingredient);
        } else if (typeDef.expectsPerProductData && typeDef.hasSubtypes) {
            const stepKey = `${type}-${cat}`;
            if (!result.steps[stepKey]) result.steps[stepKey] = [];
            result.steps[stepKey].push(ingredient);
        } else if (typeDef.removable) {
            result.removables.push(ingredient);
        } else if (typeDef.modification) {
            result.addOns.push(ingredient);
        }else if (typeDef.addable){
            result.extras.push(ingredient.p0text)
        }
    }

    return result;
}

export default function IngredientGroupList({
    ingredients,
    settings,
    selectedRemovals,
    selectedAddOns,
    selectedSteps,
    onToggleRemoval,
    onToggleAddOn,
    onSelectStep
}) {
    const mapped = mapIngredientsBySettings(ingredients, settings);

    return (
        <>
            {mapped.removables.length > 0 && (
                <ItemBlock
                    title="Ta bort ingredienser"
                    items={mapped.removables}
                    selectedItems={selectedRemovals}
                    onToggle={onToggleRemoval}
                    getId={(i) => i.p0lopnr}
                    getLabel={(i) => i.p0text}
                />
            )}

            {mapped.addOns.length > 0 && (
                <ItemBlock
                    title="Tillval"
                    items={mapped.addOns}
                    selectedItems={selectedAddOns}
                    onToggle={onToggleAddOn}
                    getId={(i) => i.p0lopnr || i.m0katnr}
                    getLabel={(i) => i.p0text || i.m0text?.toSwe?.() || "Unnamed"}
                    getPrice={(i) => i.m0pris ? i.m0pris / 100 : undefined}
                />
            )}

            {Object.entries(mapped.steps).map(([key, group]) => {
    const header = group.find(i => parseInt(i._meta.idx) === 0);
    const options = group.filter(i => parseInt(i._meta.idx) !== 0);

    return (
        <RadioBlock
            key={key}
            title={header?.p0text || header?._meta.typeDef.label || "Välj ett alternativ"}
            items={options}
            selectedItem={selectedSteps[key]}
            onSelect={(i) => onSelectStep(key, i)}
            getId={(i) => i.p0lopnr}
            getLabel={(i) => i.p0text}
            mandetory={header?._meta.typeDef.obligatory}
        />
    );
})}


            {mapped.infoOnly.length > 0 && (
                <div className="mb-3">
                    <h6>Allergener:</h6>
                    <ul className="list-unstyled mb-0">
                        {mapped.infoOnly.map((i) => (
                            <li key={i.p0lopnr}>{i.p0text}</li>
                        ))}
                    </ul>
                </div>
            )}
        </>
    );
}
